var _rect, _path, _path2, _g, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgAdditionalHealthInsurance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 106,
    viewBox: "0 0 112 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 106,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M111.375 53.5C111.375 82.4949 87.8699 106 58.875 106C29.8801 106 6.375 82.4949 6.375 53.5C6.375 24.5051 29.8801 1 58.875 1C87.8699 1 111.375 24.5051 111.375 53.5Z",
    fill: "#FFEADB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4_832",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 1,
    width: 106,
    height: 105
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M111.375 53.5C111.375 82.4949 87.8699 106 58.875 106C29.8801 106 6.375 82.4949 6.375 53.5C6.375 24.5051 29.8801 1 58.875 1C87.8699 1 111.375 24.5051 111.375 53.5Z",
    fill: "#D6E8F6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4_832)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.375,
    y: 29,
    width: 43.3969,
    height: 55.4515,
    rx: 2,
    fill: "#FDBD90"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.4033,
    y: 45.4158,
    width: 31.3422,
    height: 1.8082,
    rx: 0.904101,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.4033,
    y: 41.2319,
    width: 31.3422,
    height: 1.8082,
    rx: 0.904101,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.4033,
    y: 37.1545,
    width: 31.3422,
    height: 1.8082,
    rx: 0.904101,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.4033,
    y: 53.2512,
    width: 31.3422,
    height: 1.8082,
    rx: 0.904101,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.4023,
    y: 57.4705,
    width: 31.3422,
    height: 1.8082,
    rx: 0.904101,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.4033,
    y: 61.6187,
    width: 31.3422,
    height: 1.8082,
    rx: 0.904101,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.7266,
    y: 18,
    width: 43.3969,
    height: 55.4515,
    rx: 2,
    transform: "rotate(15 53.7266 18)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.6611,
    y: 47.9795,
    width: 31.3422,
    height: 1.8082,
    rx: 0.904101,
    transform: "rotate(15 51.6611 47.9795)",
    fill: "#4B4A50"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.7441,
    y: 43.9385,
    width: 31.3422,
    height: 1.8082,
    rx: 0.904101,
    transform: "rotate(15 52.7441 43.9385)",
    fill: "#4B4A50"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.7998,
    y: 40,
    width: 31.3422,
    height: 1.8082,
    rx: 0.904101,
    transform: "rotate(15 53.7998 40)",
    fill: "#4B4A50"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.6338,
    y: 55.5481,
    width: 31.3422,
    height: 1.8082,
    rx: 0.904101,
    transform: "rotate(15 49.6338 55.5481)",
    fill: "#4B4A50"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.542,
    y: 59.6235,
    width: 31.3422,
    height: 1.8082,
    rx: 0.904101,
    transform: "rotate(15 48.542 59.6235)",
    fill: "#4B4A50"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.4678,
    y: 63.6304,
    width: 31.3422,
    height: 1.8082,
    rx: 0.904101,
    transform: "rotate(15 47.4678 63.6304)",
    fill: "#4B4A50"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 6.27543C0 5.93148 0.291786 5.64485 0.664196 5.6341C0.779375 5.63051 11.8634 5.25789 18.3595 0.163032C18.6282 -0.0519407 19.0237 -0.0555235 19.2924 0.15945L19.2963 0.163032C25.7923 5.26148 36.8495 5.6341 36.9608 5.63768C37.3294 5.64843 37.625 5.93148 37.625 6.27902V6.32918C37.625 15.1861 36.0739 27.5685 28.4261 36.2427C23.7959 41.4952 19.2079 42.8782 19.0121 42.9355L18.8048 43L18.5898 42.9355C18.394 42.8782 13.8329 41.4952 9.20277 36.2427C1.55107 27.5649 0 15.1861 0 6.32559V6.27543Z",
    fill: "#FF7D23"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5735 21.0833L16.7399 25.0842C17.1272 25.4561 17.739 25.4557 18.1259 25.0834L27.1772 16.373C27.8312 15.7436 27.8312 14.6969 27.1772 14.0675C26.5578 13.4714 25.578 13.4714 24.9586 14.0675L17.43 21.3126L14.7896 18.776C14.1695 18.1803 13.1894 18.1814 12.5706 18.7786C11.9178 19.4086 11.9191 20.4549 12.5735 21.0833Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7054 36.3745C76.7757 39.844 73.2094 41.903 69.7398 40.9734C66.2702 40.0437 64.2112 36.4774 65.1409 33.0078C66.0706 29.5382 69.6369 27.4792 73.1064 28.4089C76.576 29.3386 78.635 32.9049 77.7054 36.3745Z",
    fill: "#E62645"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.3239 31.0047C71.7904 30.8617 71.2421 31.1783 71.0992 31.7118L70.6566 33.3635L69.0048 32.9209C68.4713 32.7779 67.923 33.0945 67.78 33.628L67.7366 33.7902C67.5936 34.3237 67.9102 34.872 68.4437 35.015L70.0955 35.4576L69.6529 37.1092C69.51 37.6427 69.8266 38.191 70.36 38.3339L70.5223 38.3774C71.0557 38.5204 71.6041 38.2038 71.747 37.6703L72.1896 36.0187L73.8411 36.4612C74.3745 36.6041 74.9229 36.2876 75.0658 35.7541L75.1093 35.5919C75.2522 35.0584 74.9356 34.5101 74.4022 34.3671L72.7507 33.9246L73.1932 32.2729C73.3362 31.7394 73.0196 31.1911 72.4861 31.0481L72.3239 31.0047Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgAdditionalHealthInsurance);
export default __webpack_public_path__ + "static/media/imgAdditionalHealthInsurance.a50ea3238786d66b3579c63fc38cba2d.svg";
export { ForwardRef as ReactComponent };